var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-user-multi-picker"},[_c('i-multi-picker',{ref:"MultiPicker",attrs:{"label-counter":"object(s)","label":_vm.label,"value":_vm.value,"fetch-options":_vm.fetchObjects,"option-label":"objectLabel","option-value":"id"},on:{"input":$val => _vm.$emit('input',$val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }